import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, UpdateWebhookDialogueHandler } from './types';
import WebhookContext from './UpdateWebhookContext';

const { ConfirmationDialogue } = vp;

type WebhookDialogueProps = {
  handleDialogue: DialogueHandler<UpdateWebhookDialogueHandler>;
};

type FC = FunctionComponent<WebhookDialogueProps>;

const UpdateWebhookDialogue: FC = ({ handleDialogue }: WebhookDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, UpdateError } = useContext(WebhookContext);
  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title="Error! The webhook was not updated."
          status="error"
          subTitle={`${UpdateError}`}
          confirm={{
            label: 'Back to Webhook',
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title="Success! The webhook was updated."
          status="success"
          subTitle="Navigate back to webhooks."
          confirm={{
            label: 'Back to Webhook',
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert],
  );
};

export default UpdateWebhookDialogue;
